import { render, staticRenderFns } from "./kalendar-day.vue?vue&type=template&id=2a2d0557&"
import script from "./kalendar-day.vue?vue&type=script&lang=js&"
export * from "./kalendar-day.vue?vue&type=script&lang=js&"
import style0 from "./kalendar-day.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports